import { render, staticRenderFns } from "./promotionSettings.vue?vue&type=template&id=03d2f0e1&scoped=true&"
import script from "./promotionSettings.vue?vue&type=script&lang=js&"
export * from "./promotionSettings.vue?vue&type=script&lang=js&"
import style0 from "./promotionSettings.vue?vue&type=style&index=0&id=03d2f0e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d2f0e1",
  null
  
)

component.options.__file = "promotionSettings.vue"
export default component.exports